import { setJobDetail, setJobDetailStep } from '../../../../../store/workspace/slice';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getJobDetailThunk } from '../../../../../store/workspace/thunks';
import MotionWrapper from '../../../../../containers/MotionWrapper';
import { useDispatch } from '../../../../../store/store';
import Loading from '../../../../../components/Loading';
import { examRules } from '../../../../../config/exam';
import Button from '../../../../../components/Button';
import { useSelector } from 'react-redux';
import styles from './style.module.scss';
import { useEffect } from 'react';
import {
    selectJobDetail,
    selectJobDetailStep,
    selectFetchingJobDetail,
} from '../../../../../store/workspace/selectors';

function JobDetail() {
    const param = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const tab = searchParams.get('tab');
    const step = useSelector(selectJobDetailStep);
    const jobDetail = useSelector(selectJobDetail);
    const isFetching = useSelector(selectFetchingJobDetail);

    useEffect(() => {
        if (param.jobId) {
            dispatch(getJobDetailThunk({
                tab,
                jobId: param.jobId,
            }));
        }

        return () => {
            dispatch(setJobDetailStep('JobDetail'));
            dispatch(setJobDetail([]));
        }
    }, []);

    const CtaTitle = () => {
        switch (jobDetail[0]?.status) {
            case 'recruitingInterview': {
                return 'Start recruiting interview';
            }
            case 'recruitingInterviewRunning': {
                return 'Continue recruiting interview';
            }
            case 'multipleChoiceExam': {
                return 'Start multiple choice exam';
            }
            case 'codingExam': {
                return 'Start coding exam';
            }
            default:
                return '';
        }
    };

    const startExam = () => {
        if (!jobDetail[0]) return;

        switch (jobDetail[0].status) {
            case 'recruitingInterview': {
                navigate('/examination/interview', {
                    state: {
                        examId: jobDetail[0].multipleChoiceExamId,
                        jobId: jobDetail[0].id,
                    }
                })
                break;
            }
            case 'recruitingInterviewRunning': {
                navigate('/examination/interview', {
                    state: {
                        examId: jobDetail[0].multipleChoiceExamId,
                        jobId: jobDetail[0].id,
                        action: 'resume',
                    }
                })
                break;
            }
            case 'multipleChoiceExam': {
                navigate('/examination/multipleChoice', {
                    state: {
                        examId: jobDetail[0].multipleChoiceExamId,
                        jobId: jobDetail[0].id,
                        jobTitle: jobDetail[0].title
                    }
                })
                break;
            }
            case 'codingExam': {
                navigate('/examination/coding', {
                    state: {
                        jobId: jobDetail[0].id,
                        examId: jobDetail[0].codingExamId,
                        langs: jobDetail[0].codingExamLanguages,
                        jobTitle: jobDetail[0].title,
                    }
                })
                break;
            }
            default:
                return;
        }
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            {isFetching && <Loading />}
            {step === 'JobDetail' && jobDetail[0] &&
                <div className={styles.job}>
                    <div className={styles.job_header}>
                        {/* <div className={styles.job_header_title}>
                            <span
                                className={styles.returnToList}
                                onClick={() => navigate('..', { relative: 'path' })}
                            >
                                Back To Job List
                            </span>
                            <span className={styles.text}>Job description</span>
                        </div> */}
                        <div className={styles.job_header_top}>
                            <div className={styles.job_header_top_company}>
                                <div className={styles.job_header_top_company_logo}>
                                    {jobDetail[0].companyLogo ? <img src={jobDetail[0].companyLogo} alt="" /> : <span>{jobDetail[0]?.companyName?.slice(0, 1)}</span>}
                                </div>
                                <span className={styles.job_header_top_company_name}>{jobDetail[0].companyName}</span>
                            </div>
                            {(jobDetail[0].status === 'multipleChoiceExam' ||
                                jobDetail[0].status === 'codingExam' ||
                                jobDetail[0].status === 'recruitingInterview') &&
                                <Button
                                    text={CtaTitle()}
                                    type='Primary'
                                    className={styles.job_header_top_btn}
                                    onClick={() => dispatch(setJobDetailStep('Rules'))}
                                />}
                        </div>
                        <div className={styles.job_header_detail}>
                            <span>{jobDetail[0].title}</span>
                            <span>Job type: {jobDetail[0].jobType.title}</span>
                            <span>
                                Base salary amount: {jobDetail[0].baseSalaryAmount || '---'} $ /{jobDetail[0].baseSalaryFrequency.title}
                            </span>
                            <span>
                                {jobDetail[0]?.city?.city} / {jobDetail[0]?.state?.state} / {jobDetail[0]?.country?.title}
                            </span>
                        </div>
                    </div>
                    <div className={styles.job_description}>
                        <span>Job description</span>
                        <p>{jobDetail[0].description}</p>
                    </div>
                </div>
            }
            {step === 'Rules' &&
                <div className={styles.rules}>
                    <span className={styles.rules_title}>Exam rules</span>
                    <div className={styles.examRules}>
                        {examRules.map((i, indx) => (<div className={styles.rule}>
                            <span className={styles.rule_title}>{indx + 1}. {i.title}</span>
                            <span className={styles.rule_description}>{i.description1}</span>
                            <span className={styles.rule_description}>{i.description2}</span>
                        </div>))}
                        <p>
                            We highly recommend opening a browser with one tab for
                            the exam and closing all other browser windows and tabs.
                        </p>
                    </div>
                    <div className={styles.rules_actions}>
                        <Button
                            text='Cancel'
                            type='Outline-Primary'
                            className={styles.rules_actions_btn}
                            onClick={() => dispatch(setJobDetailStep('JobDetail'))}
                        />
                        <Button
                            type='Primary'
                            onClick={startExam}
                            text='Agree & start exam'
                            className={styles.rules_actions_btn}
                        />
                    </div>
                </div>
            }
        </MotionWrapper>
    )
};

export default JobDetail;
